"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getConfigById = getConfigById;
exports.getImageUrl = getImageUrl;
exports.updateConfig = updateConfig;
exports.uploadImage = uploadImage;
require("core-js/modules/es6.string.starts-with");
var _requestAuth = _interopRequireDefault(require("@/utils/requestAuth"));
// 按ID查询配置
function getConfigById(id) {
  return (0, _requestAuth.default)({
    url: "/communityConfig/".concat(id),
    method: 'get'
  });
}

// 按ID更新配置
function updateConfig(id, value) {
  return (0, _requestAuth.default)({
    url: '/communityConfig',
    method: 'put',
    data: {
      id: id,
      value: value
    }
  });
}

// 上传图片（返回相对路径）
function uploadImage(file) {
  var path = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '/';
  var formData = new FormData();
  formData.append('file', file);
  return (0, _requestAuth.default)({
    url: '/image/upload',
    method: 'post',
    data: formData,
    params: {
      path: path
    },
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
}

// 数据库路径转展示URL
function getImageUrl(dbPath) {
  if (!dbPath) return '';
  if (dbPath.startsWith('http')) return dbPath;
  return process.env.VUE_APP_COMMENT_IMAGE_URL + dbPath;
}